import { render } from "./ConversationTranscript.vue?vue&type=template&id=64763e0d&scoped=true&lang=pug"
import script from "./ConversationTranscript.vue?vue&type=script&lang=js"
export * from "./ConversationTranscript.vue?vue&type=script&lang=js"

import "./ConversationTranscript.vue?vue&type=style&index=0&id=64763e0d&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64763e0d"]])

export default __exports__